import { render, staticRenderFns } from "./SendDocumentRemindHistoryTab.vue?vue&type=template&id=54f81138&lang=pug"
import script from "./SendDocumentRemindHistoryTab.vue?vue&type=script&lang=ts"
export * from "./SendDocumentRemindHistoryTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports